﻿/*!
  * Furillo modal.js v5.3.2
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
import Modal from 'Vendor/bootstrap/js/dist/modal.js';
import Carousel from 'Vendor/bootstrap/js/dist/carousel.js';
import ajaxPartials from './ajax-partials.js';

export default function extendedModal(modal) {

    const getOpenerData = function (opener) {
        // Determine type of modal based on the opener
        // Right now there's only support for a-tag
        // and image. Build support for iframes and buttons and more

        //opener.tagName opener trigger.getAttribute("href")

        if (opener.hasAttribute('data-html-holder')) {
            return {                
                type: 'HTML',
                html: document.getElementById(opener.getAttribute('data-html-holder')).innerHTML
            }
        }

        return {
            url: opener.getAttribute('href'),
            type: 'IMG',
            currentPageId: opener.getAttribute('data-current-page-id'),
            blockId: opener.getAttribute('data-block-id'),
            contentId: opener.getAttribute('data-content-id')
        }
    };

    const init = function () {

        // Get all image gallery modals and listen to the show event
        modal.addEventListener('show.bs.modal', evt => {

            const opener = evt.relatedTarget;
            if (!opener)
                return;

            const openerData = getOpenerData(opener);
            const modalBody = modal.querySelector('div.modal-body');
            
            const displaySingleImage = function () {
                const img = document.createElement('img');
                img.setAttribute('src', openerData.url);
                img.classList.add('img-fluid');

                modalBody.innerHTML = '';
                modalBody.appendChild(img);
            };

            const displayCarousel = function () {
                modalBody.setAttribute('data-ajax-url', '/partials/imagegallery/' + openerData.currentPageId + '/' + openerData.blockId + '/carousel');
                ajaxPartials.makeRequest(modalBody, function () {

                    // Initiate carousel from loaded partial
                    const carousel = Carousel.getOrCreateInstance(modal.querySelector('.modal-body .carousel'));

                    // Check if we have content, if so we can send the user to the correct slide
                    if (!openerData.contentId || openerData.contentId.length === 0)
                        return;

                    const button = modal.querySelector('.modal-body .carousel .carousel-indicators button[data-content-id="' + openerData.contentId + '"]');
                    if (!button)
                        return;

                    const index = parseInt(button.getAttribute('data-bs-slide-to'));
                    if (isNaN(index))
                        return;

                    carousel.to(index);
                });
            };
                        
            if (openerData.type === 'IMG') {

                modal.querySelector('div.modal-dialog').classList.add('modal-xl');
                modal.classList.add('image');

                if (!openerData.blockId || openerData.blockId.length === 0 || !openerData.currentPageId || openerData.currentPageId.length === 0) {
                    displaySingleImage();
                    return;
                }

                displayCarousel();
                return;
            }

            if (openerData.type === 'HTML') {
                modal.querySelector('div.modal-dialog').classList.add('modal-lg');
                modal.classList.add('html');

                modalBody.innerHTML = openerData.html;
                return;
            }


        });

        modal.addEventListener('hidden.bs.modal', evt => {
            // Reset classes
            modal.setAttribute('class', 'modal');
            modal.querySelector('div.modal-dialog').setAttribute('class', 'modal-dialog modal-dialog-centered');
        });
    };

    init();
}